export default __webpack_public_path__ + "static/media/requests_ic.e0b2c8e9.svg";